import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import Group_no_row from './group_row.jsx';
import Pagination from '../../ui/pagination';
import Reset_group_Pop from './Reset_Group_pop.jsx';
import { userService } from "../../../_services";
import Asign_Edit_Group from './AssignEditGroupDialog.jsx';
import GrandparentConfirm from './GrandparentConfirmDialog.jsx';
import { Card, CardContent } from "../../ui/card";
import { Input } from "../../ui/input";
import { Tabs, TabsList, TabsTrigger } from "../../ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { Loader2, X } from 'lucide-react';
import { debounce } from 'lodash';

class Groupno_Page extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shortname: '',
            fullName: '',
            pageOfItems: [],
            searchInput: "",
            columnSearch: "",
            filteredData: [],
            reset_title: 'Reset Group Number',
            isPrimary_group: 'false',
            show_reset_group_popup: false,
            Addedit_title: '',
            show_add_edit_group_popup: false,
            poptype: '',
            group_user_id: '',
            group_no: '',
            username: '',
            group_loader: false,
            filtered_text: "All",
            selected_tab: "Assigned",
            isSearching: false,
            // Add local state for group data (was from Redux)
            Group_Data: [],
            grouptemp: []
        }
        this.onChangePage = this.onChangePage.bind(this);
        this.handletab = this.handletab.bind(this);
        this.toggle_reset_group_pop = this.toggle_reset_group_pop.bind(this);
        this.toggle_add_edit_group_pop = this.toggle_add_edit_group_pop.bind(this);
        this.success_save = this.success_save.bind(this);
        this.restrict_release = this.restrict_release.bind(this);
        
        // Create debounced search function
        this.debouncedSearch = debounce(this.performSearch, 300);
    }

    componentDidMount() {
        let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        if (this.state.Group_Data.length === 0) {
            this.GroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        } else {
            this.GroupList_redux();
        }
    }

    // Optimized filter logic - reusable and clean
    matchesSearch = (item, searchTerm) => {
        if (!searchTerm) return true;
        
        const lowerSearch = searchTerm.toLowerCase();
        const groupNumber = (item.groupNumber || '').toLowerCase();
        const fullName = (item.fullName || '').toLowerCase();
        const parentName = (item.p_FullName || '').toLowerCase();
        
        return (
            groupNumber.includes(lowerSearch) ||
            fullName.includes(lowerSearch) ||
            parentName.includes(lowerSearch)
        );
    }

    // Perform the actual search (debounced)
    performSearch = (searchTerm) => {
        const { grouptemp } = this.state;
        
        // If search is empty, show all data
        if (!searchTerm || searchTerm.trim() === '') {
            this.setState({ 
                Group_Data: grouptemp,
                filtered_text: 'All',
                isSearching: false
            });
            return;
        }
        
        // Filter without expensive deep clone
        const filtered = grouptemp.filter(item => 
            this.matchesSearch(item, searchTerm)
        );
        
        this.setState({ 
            Group_Data: filtered.length > 0 ? filtered : [],
            filtered_text: 'All',
            isSearching: false
        });
    }

    // Handle input change (controlled)
    handleSearchChange = (e) => {
        const searchTerm = e.target.value;
        
        // Update input immediately for responsive UI
        this.setState({ 
            searchInput: searchTerm,
            isSearching: true 
        });
        
        // Debounce the actual filtering
        this.debouncedSearch(searchTerm);
    }

    // Clear search
    clearSearch = () => {
        this.setState({ 
            searchInput: '',
            Group_Data: this.state.grouptemp,
            filtered_text: 'All',
            isSearching: false
        });
        this.debouncedSearch.cancel();
    }

    // Cleanup on unmount
    componentWillUnmount() {
        if (this.debouncedSearch) {
            this.debouncedSearch.cancel();
        }
    }

    handleSearchFilter = (e) => {
        let serachText = e.target.value;
        
        let userlistobj = JSON.parse(JSON.stringify(this.state.grouptemp)).filter(function (e1) {
            if (e1.p_FullName != null && e1.fullName != null) {
                return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.p_FullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.fullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            }
            if (e1.p_FullName == null && e1.fullName != null) {
                return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.fullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            }
            if (e1.p_FullName != null && e1.fullName == null) {
                return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.p_FullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            }
            else {
                return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            }
        });
        
        if (userlistobj.length > 0) {
            this.setState({ filtered_text: 'All', Group_Data: userlistobj });
        } else {
            this.setState({ filtered_text: 'All', Group_Data: [{}] });
        }
    }

    GroupList(UserId, UserName) {
        this.setState({ group_loader: true });
        try {
            // ONLY call api/Account/Grouplist (matching live)
            userService.GroupList(UserId, UserName)
                .then(
                    apidata => {
                        //console.log('GroupList API response:', apidata);
                        this.setState({ 
                            Group_Data: apidata,
                            grouptemp: apidata,
                            group_loader: false
                        });
                    }
                )
                .catch(error => {
                    console.error('Error in GroupList API:', error);
                    this.setState({ group_loader: false });
                });
        }
        catch (error) {
            console.error('Error fetching group list:', error);
            this.setState({ group_loader: false });
        }
    }

    GroupList_redux() {
        this.setState({ group_loader: true });
        let reduxGroupData = this.state.Group_Data[0];
        let reduxTempData = this.state.grouptemp;
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        try {
            this.setState({ Group_Data: reduxGroupData, grouptemp: reduxTempData, group_loader: false });
            this.compareGroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }
        catch (error) {
            console.error('Error loading from redux:', error);
            this.setState({ group_loader: false });
        }
    }

    compareGroupList(UserId, UserName) {
        try {
            userService.GroupList(UserId, UserName)
                .then(
                    apidata => {
                        console.log('compareGroupList API response:', apidata);
                        const reduxJson = JSON.stringify(this.state.Group_Data[0]);
                        const apidataJson = JSON.stringify(apidata);
                        if (!(reduxJson === apidataJson)) {
                            this.setState({ Group_Data: apidata, grouptemp: apidata });
                        }
                    }
                )
                .catch(error => {
                    console.error('Error in compareGroupList API:', error);
                });
        }
        catch (error) {
            console.error('Error comparing group list:', error);
        }
    }

    onChangePage(pageOfItems) {
        this.setState({ pageOfItems: pageOfItems });
    }

    handletab(tabname) {
        // Fix: Check if grouptemp is an array before filtering
        if (!this.state.grouptemp || !Array.isArray(this.state.grouptemp)) {
            return;
        }

        // Cancel any pending search
        if (this.debouncedSearch) {
            this.debouncedSearch.cancel();
        }

        let filtered = [];
        filtered = this.state.grouptemp.filter(function (item) {
            if (item.groupStatus && item.groupStatus.match(tabname)) {
                return item;
            }
            return false;
        });

        // Always set filtered results (even if empty array)
        // Clear search input and reset state
        this.setState({ 
            Group_Data: filtered, 
            filtered_text: tabname, 
            selected_tab: tabname, 
            searchInput: '',
            pageOfItems: [],
            isSearching: false
        });
    }

    toggle_reset_group_pop = (e, shouldRefresh = false) => {
        e.stopPropagation();
        const target = e.currentTarget || e.target;
        
        // If no target (closing popup), just toggle state
        if (!target) {
            this.setState({ show_reset_group_popup: !this.state.show_reset_group_popup });
            // Only refresh if explicitly requested (after successful reset)
            if (shouldRefresh) {
                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                this.GroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            }
            return;
        }
        
        const groupNumber = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        const username = target.getAttribute('data-username') || target.getAttribute('username');
        const isPrimary = target.classList.contains('true');

        if (groupNumber && username) {
            this.setState({
                show_reset_group_popup: !this.state.show_reset_group_popup,
                reset_title: isPrimary ? 'Reset Primary Group Number' : 'Reset Group Number',
                isPrimary_group: isPrimary ? 'true' : 'false',
                group_no: groupNumber,
                username: username
            });
        } else {
            this.setState({ show_reset_group_popup: !this.state.show_reset_group_popup });
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            this.GroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }
    }

    toggle_add_edit_group_pop = (e) => {
        e.stopPropagation();
        const target = e.currentTarget || e.target;
        const poptype = target.getAttribute('data-poptype') || target.getAttribute('poptype');
        const groupNumber = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        const userId = target.getAttribute('data-userid') || target.getAttribute('userid');

        if (poptype === 'assign') {
            this.setState({
                show_add_edit_group_popup: !this.state.show_add_edit_group_popup,
                Addedit_title: 'Assign New Group Number ' + groupNumber,
                group_no: groupNumber,
                poptype: poptype
            });
        } else if (poptype === 'edit') {
            this.setState({
                show_add_edit_group_popup: !this.state.show_add_edit_group_popup,
                Addedit_title: 'Edit Group Number ' + groupNumber,
                group_user_id: userId,
                group_no: groupNumber,
                poptype: poptype
            });
        } else {
            this.setState({ show_add_edit_group_popup: !this.state.show_add_edit_group_popup });
        }
    }

    success_save = (e) => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.GroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        this.setState({ show_add_edit_group_popup: false });
    }

    restrict_release(event) {
        const target = event.currentTarget || event.target;
        const targetvalue = target.getAttribute('data-tagname') || target.getAttribute('tagname');
        const groupno = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.UpdateGroupNumber(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1], groupno, targetvalue);
    }

    UpdateGroupNumber(UserId, UserName, GroupNumber, Action) {
        try {
            userService.UpdateGroupNumber(UserId, UserName, GroupNumber, Action)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code === '1') {
                                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                                this.setState({ selected_tab: "Assigned" });
                                this.GroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
                            }
                        }
                    }
                );
        }
        catch (error) {
            console.error('Error updating group number:', error);
        }
    }

    render() {
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) return <Navigate replace to="/signup" />
        localStorage.setItem('pagename', 'groupno');
        let { searchInput, pageOfItems, isSearching } = this.state;
        const dataToDisplay = pageOfItems;

        return (window.atob(localStorage.getItem('UserRole')) === "Admin" ?
            <div className="w-full space-y-6">
                {/* Heading */}
                <h1 className="text-2xl font-semibold text-brand-dark">Group Numbers</h1>

                {/* Search and Tabs Row */}
                <div className="flex items-center justify-between gap-4">
                    <div className="relative max-w-md flex-1">
                        <Input
                            type="text"
                            placeholder="Search by group number, name, or parent..."
                            value={searchInput}
                            onChange={this.handleSearchChange}
                            className="pr-20"
                            disabled={this.state.group_loader || !this.state.grouptemp.length}
                        />
                        
                        {/* Loading indicator */}
                        {isSearching && (
                            <Loader2 className="absolute right-10 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-gray-400" />
                        )}
                        
                        {/* Clear button */}
                        {searchInput && !isSearching && (
                            <button
                                onClick={this.clearSearch}
                                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded transition-colors"
                                aria-label="Clear search"
                                type="button"
                            >
                                <X className="h-4 w-4 text-gray-500" />
                            </button>
                        )}
                    </div>
                    <Tabs value={this.state.selected_tab}>
                        <TabsList>
                            <TabsTrigger
                                value="Assigned"
                                onClick={() => this.handletab('Assigned')}
                                disabled={this.state.group_loader || !this.state.grouptemp.length}
                            >
                                Assigned
                            </TabsTrigger>
                            <TabsTrigger
                                value="Unassigned"
                                onClick={() => this.handletab('Unassigned')}
                                disabled={this.state.group_loader || !this.state.grouptemp.length}
                            >
                                Unassigned
                            </TabsTrigger>
                            <TabsTrigger
                                value="Restricted"
                                onClick={() => this.handletab('Restricted')}
                                disabled={this.state.group_loader || !this.state.grouptemp.length}
                            >
                                Restricted
                            </TabsTrigger>
                        </TabsList>
                    </Tabs>
                </div>

                {/* Card with Table only */}
                <Card>
                    <CardContent className="p-0">
                        {/* Table */}
                        {this.state.group_loader ? (
                            <div className="flex items-center justify-center py-12">
                                <Loader2 className="h-8 w-8 animate-spin text-brand-accent" />
                            </div>
                        ) : (
                            <>
                                <div className="rounded-md border">
                                    <Table>
                                        <TableHeader>
                                            <TableRow>
                                                <TableHead>Group Number</TableHead>
                                                <TableHead>Full Name</TableHead>
                                                <TableHead>Parent Affiliate</TableHead>
                                                <TableHead>Grandparent Affiliate</TableHead>
                                                <TableHead>Commission($)</TableHead>
                                                <TableHead>Status</TableHead>
                                                <TableHead>Actions</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {dataToDisplay && dataToDisplay.length > 0 ? (
                                                dataToDisplay.map((grouprow, index) =>
                                                    <Group_no_row
                                                        key={Math.random()}
                                                        index={index}
                                                        {...grouprow}
                                                        toggle_reset_popup={this.toggle_reset_group_pop.bind(this)}
                                                        toggle_add_edit_popup={this.toggle_add_edit_group_pop.bind(this)}
                                                        restrict_release={this.restrict_release.bind(this)}
                                                    />
                                                )
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={7} className="text-center py-8 text-gray-500">
                                                        No records found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>

                                {/* Pagination */}
                                <Pagination items={this.state.Group_Data} onChangePage={this.onChangePage} searchlength={0} />
                            </>
                        )}
                    </CardContent>
                </Card>

                {/* Reset Popup*/}
                {this.state.show_reset_group_popup === true ? (
                    <div className="resetgroup_box">
                        <Reset_group_Pop toggle_reset_popup={this.toggle_reset_group_pop.bind(this)} title={this.state.reset_title} group_no={this.state.group_no} grouptype={this.state.isPrimary_group} username={this.state.username} />
                    </div>
                ) : null}

                {/* Assign or edit Popup - Only render when needed */}
                {this.state.show_add_edit_group_popup && (
                    <Asign_Edit_Group 
                        open={this.state.show_add_edit_group_popup}
                        onClose={() => this.setState({ show_add_edit_group_popup: false })}
                        onSave={this.success_save}
                        poptype={this.state.poptype}
                        userid={this.state.group_user_id}
                        groupnumber={this.state.group_no}
                        title={this.state.Addedit_title}
                    />
                )}
            </div> : <Navigate replace to="/page-not-found" />
        )
    }
}
export default Groupno_Page;
